<!--
  功能：功能描述
  作者：missfox
  邮箱：missfoxw@163.com
  时间：2021年09月24日 14:44:01
  版本：v1.0
  修改记录：
  修改内容：
  修改人员：
  修改时间：
-->
<template>
  <div class="history">
    <!-- 头部 -->
    <div class="header">
      <CommonFilter @click="openFilter(true)" @change="filterData"></CommonFilter>
      <!-- <el-date-picker
            v-model="times"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="timestamp"
            popper-class="date-picker">
        </el-date-picker> -->
      <div class="time-container" @click="show = true">{{ dateStr ? dateStr : '选择日期' }}</div>
      <van-calendar v-model="show" type="range" allow-same-day :default-date="getDefaultDate()" :min-date="getMinDate()" @confirm="onConfirm" />
    </div>

    <!-- 列表 -->
    <div class="list" v-if="list.length">
      <div class="block" v-for="(item, index) in list" :key="item.Id" :id="'lv-list' + index">
        <implementItemHeader :name="item.ProfileName" :avatar="item.ImgUrl" :time="item.NursingDate.split('T')[0] + ' ' + item.Nursingtime" :room="item.RoomNo"></implementItemHeader>
        <div class="line"></div>

        <div class="task-container">
          <el-image class="img" :src="timePhoto"></el-image>
          <div class="task" style="margin-right: auto">
            <span>{{ item.DrugName }} </span>
            <span v-if="item.FrequencyTypeStr">({{ item.FrequencyTypeStr }} )</span>
          </div>
          <!-- <div v-if="item.value === '0'" class="task">{{ item.Amount }}/{{ item.Unit }}</div> -->
        </div>

        <div class="footer">
          <div class="result" :style="{ color: item.value == 0 ? '#029FD1' : '#F22D2E' }">
            <div>{{ statusList[item.value] || '' }}-</div>
            <div class="time-message">
              <div>于{{ item.Cdate }}由{{ item.CUser }}</div>
              <div v-if="item.remark" class="remark">{{ item.remark }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <tips v-else></tips>

    <!-- 分页 -->
    <el-pagination
      background
      class="pagination"
      :current-page="currentPage"
      :page-size="pagesize"
      :pager-count="5"
      layout="total,  prev, pager, next"
      :total="total"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
import CommonFilter from '@/common/common-filter.vue'

import implementItemHeader from '@/common/implement-item-header.vue'
import timePhoto from '@/assets/imgs/time.png'
import tips from '@/common/tips.vue'
import { formatDate, intitime } from '@/tool'

export default {
  // 局部注册的组件
  components: {
    CommonFilter,
    implementItemHeader,
    tips
  },
  // 组件状态值
  data() {
    return {
      times: [],
      floorArr: [],
      roomArr: [],
      currentPage: 1,
      pagesize: 15,
      total: 0,
      show: false,
      dateStr: '',
      timePhoto,
      userList: [],
      statusList: ['完成', '拒绝', '缺席', '没有必要', '未完成', '延期']
    }
  },
  // 计算属性
  computed: {
    list() {
      if (this.userList.length) {
        let resultData = this.userList
        // 筛选房间
        if (this.roomArr.length) {
          resultData = resultData.filter((val) => this.roomArr.find((el) => el === val.RoomNo))
        }
        this.total = resultData.length
        // 分页
        return resultData.slice((this.currentPage - 1) * this.pagesize, (this.currentPage - 1) * this.pagesize + this.pagesize)
      } else {
        return []
      }
    }
  },
  // 侦听器
  watch: {},
  created() {
    this.times = [intitime(null, 'yyyy-MM-dd'), intitime('', 'yyyy-MM-dd')]
    this.getList()
  },
  // 组件方法
  methods: {
    getList() {
      const params = {
        begin: this.times[0],
        end: this.times[1],
        rooms: []
      }
      this.currentPage = 1
      this.$axios
        .post('/Pad/NoGetMedicalSignsHistory', params)
        .then((res) => {
          this.userList = res.data.obj || []
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    getMinDate() {
      const date = new Date()
      date.setTime(date.getTime() - 3600 * 1000 * 24 * 30 * 5)
      return date
    },

    getDefaultDate() {
      let nowDate = new Date()
      return [new Date(formatDate(nowDate)), new Date(formatDate(nowDate))]
    },

    // 时间筛选
    onConfirm(times) {
      const [start, end] = times
      this.dateStr = `${formatDate(start, '/')} - ${formatDate(end, '/')}`
      times[0] = intitime(start.getTime(), 'yyyy-MM-dd')
      times[1] = intitime(end.getTime(), 'yyyy-MM-dd')
      this.times = times
      this.show = false
      this.getList()
    },

    // 筛选条件
    filterData(roomArr) {
      this.currentPage = 1
      this.roomArr = roomArr
    },

    // 分页
    handleCurrentChange(size) {
      this.currentPage = size
      this.$nextTick(() => {
        document.getElementById('lv-list0').scrollIntoView(false)
      })
    }
  }
}
</script>

<style scoped>
.history {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.history >>> .el-date-editor {
  border: none;
}
.header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px;
  background: #fff;
  box-sizing: border-box;
}

.header >>> .el-date-editor {
  width: 274px;
  height: 35px;
  background: #f4f4f4;
}
.header >>> .el-date-editor .el-range__icon {
  font-size: 16px;
  line-height: 33px;
  width: 25px;
  border: none;
}
.header >>> .el-date-editor .el-range-separator {
  line-height: 31px;
  font-size: 12px;
}
.header >>> .el-range-input {
  font-size: 12px;
  background: #f4f4f4;
}
.header >>> .el-icon-time + .el-range-input {
  text-align: left;
}
.header >>> .el-range-input {
  text-align: right;
}
.header >>> .el-range-separator {
  color: #c7c9cc;
}

.list {
  flex: 1;
  padding: 10px 15px 0px 15px;
  overflow-y: auto;
}

.block {
  background: #fff;
  padding: 12px;
  margin-bottom: 15px;
  border-radius: 4px;
}
.line {
  width: 100%;
  height: 1px;
  background: #ebebeb;
  margin-bottom: 12px;
}
.time-container {
  font-size: 12px;
}

.task-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 12px 0;
}
.task-container .task {
  font-size: 16px;
  font-weight: 500;
  line-height: 23px;
  color: #029fd1;
}
.task-container .img {
  width: 26px;
  height: 26px;
}
.footer .img {
  width: 26px;
  height: 26px;
}
.footer .img-check {
  margin-right: 15px;
}

.result {
  display: flex;
}
.result .img {
  width: 17px;
  height: 17px;
}
.result .remark {
  margin-top: 0.08rem;
  font-size: 0.533333rem;
  color: #434649 !important;
}

.pagination {
  width: 100%;
  display: flex;
  justify-content: center;
  box-sizing: border-box;
  margin: 10px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/cure/record.vue